import React from 'react';
import PropTypes from 'prop-types';
import { Trans, translate } from 'react-i18next';

import { Content, SimpleList } from 'components/Common';
import { Header } from 'components';

export const Contact = ({ t, region }) => (
  <div>
    <Header title={t('contact.title')} description={t('contact.description')} />

    <Content>
      <div className="row">
        <div className="columns small-12 medium-6 large-4">
          <h4>{t('contact.customerService.heading')}</h4>

          <SimpleList>
            <SimpleList.Item>
              <SimpleList.Link href={`mailto:${region.customerSupport.email}`}>
                {region.customerSupport.email}
              </SimpleList.Link>
            </SimpleList.Item>
            <SimpleList.Item>
              <SimpleList.Link
                href={`callto:${region.customerSupport.phonenumber}`}
              >
                {region.customerSupport.phonenumber}
              </SimpleList.Link>
            </SimpleList.Item>
          </SimpleList>

          <Trans
            parent="p"
            className="small"
            i18nKey="contact.customerService.description"
          >
            Our customer service is available <strong>7am-6pm</strong> on
            working days.
          </Trans>
        </div>

        <div className="columns small-12 medium-6 large-4">
          <h4>{t('contact.address.heading')}</h4>

          <SimpleList>
            <SimpleList.Item>Annankatu 27 A, 3 krs.</SimpleList.Item>
            <SimpleList.Item>00100 Helsinki</SimpleList.Item>
            <SimpleList.Item>Finland</SimpleList.Item>
          </SimpleList>
        </div>

        <div className="columns small-12 medium-6 large-4">
          <h4>{t('contact.company.heading')}</h4>

          <SimpleList>
            <SimpleList.Item>Freska Finland Oy</SimpleList.Item>
            <SimpleList.Item>2692895-8</SimpleList.Item>
          </SimpleList>
        </div>
      </div>
    </Content>
  </div>
);

Contact.propTypes = {
  t: PropTypes.func.isRequired,
  region: PropTypes.object.isRequired
};

export default translate()(Contact);



// WEBPACK FOOTER //
// ./src/components/Contact/Contact.js